'use client';
import styled from 'styled-components';
import { theme } from 'styles/theme';

const Hamburger = ({ open, active}) => {
	return (
		<StyledCloseButton className={`menu-hamburger ${open ? 'open' : ''} ${active ? 'active' : ''}`}>
			<svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle opacity="0.5" cx="21" cy="21" r="20" transform="rotate(-90 21 21)" stroke="white" />
				<path d="M17.464 24.535L24.536 17.465M17.464 17.465L24.536 24.535" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
			</svg>
		</StyledCloseButton>
	);
};
const StyledCloseButton = styled.div`
    cursor: pointer;
    display: inline-flex;
    transition: ${theme.transition};
    gap: 15px;
    position: relative;
    .text-content {
        position: relative;
        z-index: 3;
        color: ${theme.colors.white};

        p {
            font-weight: 600;
            font-size: 1rem; /* 16px ÷ 16 */
            line-height: 1.25rem; /* 20px ÷ 16 */
            letter-spacing: 0; /* 0% = normal spacing */
            transition: ${theme.transition};
        }
    }
    svg {
        transition: ${theme.transition};

        circle {
            transition: ${theme.transition};

        }
    }
    &:after, &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        transition: ${theme.transition};
    }
    &:hover {
        &:after {
            width: 100%;
            height: 100%;
            opacity: 1;
        }
        p {
            color: ${theme.colors.secondaryGreen} !important;
        }
        svg {
            transform: rotate(0);

            circle {
                fill: ${theme.colors.secondaryGreen};
            }
        }
    }

`;
export default Hamburger;